<template>
    <div>
        <div>
            <div class="common-header-right">
                <div class="common-header-block">
                    <el-date-picker
                            type="daterange"
                            value-format="yyyy-MM-dd"
                            v-model="date"
                            range-separator="-"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"/>
                </div>
                <div class="common-header-block">
                    <el-input v-model="searchVal" placeholder="请输入名称/ID">
                        <template slot="prepend">俱乐部</template>
                    </el-input>
                </div>
                <div class="common-header-block">
                    <el-button type="primary" @click="getList()">查询</el-button>
                </div>
            </div>
        </div>
        <div>
            <strong class="common-text-item" v-text="`浏览总数：${clubPromoteList.totalViewTimes}`"></strong>
            <strong class="common-text-item" v-text="`注册总数量：${clubPromoteList.totalRegTimes}`"></strong>
            <strong class="common-text-item" v-text="`下载总数量：${clubPromoteList.totalDownTimes}`"></strong>
        </div>
        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="clubPromoteList.beanList"
                    row-key="randomId"
                    height="100%">
                <el-table-column type="index" label="编号" align="center"/>
                <el-table-column align="center" label="俱乐部名称" prop="clubName"/>
                <el-table-column align="center" label="俱乐部ID" prop="randomId"/>
                <el-table-column align="center" sortable label="浏览数量" prop="viewTimes"/>
                <el-table-column align="center" sortable label="注册数量" prop="regTimes"/>
                <el-table-column align="center" sortable label="下载数量" prop="downTimes"/>
            </el-table>
        </div>
        <el-pagination
                class="common-el-pagination"
                background
                layout="prev,pager,next,jumper"
                :pager-count="5"
                :page-size="20"
                :current-page="currentPage"
                @current-change="getList($event)"
                :total="clubPromoteList.total"/>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                date: null,
                searchVal: '',
                currentPage: 1,
            }
        },
        computed: {
            ...mapState('club', ['clubPromoteList']),
        },
        created() {
            this.getList()
        },
        methods: {
            ...mapActions('club', ['getClubPromoteList']),
            getList(page = 1) {
                this.loading = true;
                this.getClubPromoteList({
                    content: this.searchVal,
                    start: this.date && this.date[0] || '',
                    end: this.date && this.date[1] || '',
                    page
                }).then(() => {
                    this.loading = false
                })
            }
        }
    }
</script>